module.exports = __webpack_public_path__ + "static/media/intec.521fc904.png";